import camelCase from "lodash-es/camelCase";
import get from "lodash-es/get";
import React, { PureComponent, ReactNode } from "react";
import styled from "styled-components";

import { footerInteractionTracking } from "../../services/analytics.service";
import theme, { media } from "../../theme";
import Hyperlink from "../Hyperlink";

import {
  ISocialNetwork,
  socialNetworksDictionary,
} from "./socialNetworksDictionary";

const Wrapper = styled.article`
  text-align: center;
  font-size: ${theme.fontSizes.big};
  font-family: ${theme.fonts.subtitle};
  margin-top: 30px;
`;

const NetworksWrapper = styled.ul`
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 0;
`;

const NetworkItem = styled.li`
  list-style-type: none;

  &:not(:first-of-type) {
    margin-left: ${theme.margins.marginBase};
  }
`;

const Image = styled.img`
  height: 30px;
  width: 30px;

  ${media.laptop} {
    filter: sepia(100%) brightness(250%) hue-rotate(1deg);

    &:hover {
      filter: sepia(100%) brightness(180%) hue-rotate(1deg);
    }
  }
`;

interface IProps {
  networksKeys?: ISocialNetwork[];
  title?: string;
}

export default class SocialNetworks extends PureComponent<IProps> {
  public static defaultProps: Partial<IProps> = {
    networksKeys: ["instagram", "facebook", "youtube", "twitter"],
    title: "",
  };

  public render(): ReactNode {
    const { networksKeys, title } = this.props;

    return (
      <Wrapper>
        {title}
        <NetworksWrapper>
          {networksKeys!.map((networkKey: ISocialNetwork, index: number) => {
            const target = this.getTarget(networkKey);

            return (
              <NetworkItem key={`${networkKey}-${index}`}>
                <Hyperlink
                  to={target}
                  onClick={(): void =>
                    footerInteractionTracking(camelCase(networkKey))
                  }
                >
                  <Image
                    src={get(socialNetworksDictionary, [networkKey, "img"])}
                    alt={networkKey}
                  />
                </Hyperlink>
              </NetworkItem>
            );
          })}
        </NetworksWrapper>
      </Wrapper>
    );
  }

  protected getTarget = (networkKey: ISocialNetwork): string => {
    return get(socialNetworksDictionary, [networkKey, "link"]);
  };
}
